import { apiClient } from "../config";

async function getQANotifications(queryParams: any) {
  const res = await apiClient.get(`/admin/dashboard/widget/qa-notifications`, {
    params: queryParams,
  });
  return res.data;
}

export default getQANotifications;
